module.exports = __webpack_public_path__ + "img/nsf_logo.383b9562.png";